import { GridDensity } from '@mui/x-data-grid-pro'
import { selectImportPageState } from '@user/store/import/slice'
import {
  IUserPreferenceGeneralListItemType,
  userGeneralPreferencesList,
} from '@user/store/userPreferences/userPreferencesGeneral'
import { useSelector } from 'react-redux'

export function useData() {
  const userGeneralPreferences = useSelector(userGeneralPreferencesList)

  const importPageState = useSelector(selectImportPageState)

  const loading = importPageState?.loading

  const densityModeUserGeneralPreference = userGeneralPreferences?.find(
    (row) => row?.type == IUserPreferenceGeneralListItemType.ImportDensityMode,
  )
  const stringValue = densityModeUserGeneralPreference?.value ?? 'standard'
  const densityMode = stringValue as GridDensity

  const pageSize = sessionStorage?.pageSize
    ? parseInt(sessionStorage?.pageSize)
    : importPageState?.perPage

  const page = importPageState?.page ?? -1

  const count = importPageState?.count ?? 0

  return { count, densityMode, pageSize, page, loading }
}
export type UseData = ReturnType<typeof useData>
